// extracted by mini-css-extract-plugin
module.exports = {"footer":"a10a3f92e9--footer--ziZiC","container":"a10a3f92e9--container--xJR2F"};